import { stateKeys } from '../../types';

export const isElementVisible = (state, elementId) => state[stateKeys.GENERAL].elementVisibility[elementId];
export const getLinkedWellboreId = (state) => state[stateKeys.GENERAL].linkedWellboreId;
export const getRankingType = (state) => state[stateKeys.GENERAL].rankingType;
export const getSelectedResultGroup = (state) => state[stateKeys.GENERAL].selectedResultGroup;
